
import { useEffect, useState } from "react";
import { cloneDeep } from "lodash";
import { useSearchParams } from "react-router-dom";
import { callAPIForQuery } from "../../utilities/service";
import { Loader } from "../common/Loader";
import { useCustomContext } from "../../state/CustomContext";
import moment from "moment";
import { downloadFile } from "../../utilities/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
export const AmbulanceTrack = () => {
    const context = useCustomContext();
    const { state } = context;

    const [appointment, setAppointment] = useState<any>([])
    const [statusTrack, setStatusTrack] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState<any>({});

    const [searchParams] = useSearchParams(); // Get query params
    const appointment_id = searchParams.get("appointment_id"); // Extract specific param
    useEffect(() => {
        refreshComponent();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    const updateInputInfo = (key: string, value: string) => {
        const inputCopy: any = cloneDeep(input);
        inputCopy[key] = value;
        setInput(inputCopy);
    }
    const refreshComponent = () => {
        setInput({})
        getPatient();
    }
    const getPatient = async () => {
        let xmlString = '<profile>';
        xmlString += `<id>${appointment_id}</id>`;
        xmlString += '</profile>'
        setLoading(true)
        const result = await callAPIForQuery({ input: xmlString, type: 'GetAppointmentsByDate' }, 'post')
        setLoading(false)
        if (!result.error) {
            setAppointment(result[0][0]);
            setStatusTrack(result[1])
        }
    }
    const handleFileUpload = (input: any, key: string) => {
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = function (e: any) {
                const base64String = e.target.result.split(',')[1]; // Extract Base64
                const fileExtension = file.name.split('.').pop(); // Get file extension
                updateInputInfo(key, `${fileExtension}|||${base64String}`);
                // console.log("Base64 String:", base64String);
                // console.log("File Extension:", fileExtension);
            };

            reader.readAsDataURL(file);
        }
    }

    const onSave = async () => {
        let steps: any = [];
        Object.keys(input).forEach((val: any) => {
            steps.push({ "field": val, "value": input[val] })
        })
        const startKm = statusTrack.find((status: any) => status.field === "start_km");
        if (startKm?.value && Number(input.destination_km) <= Number(startKm.value)) {
            alert("The startKM cant be larger than destination KM")
        } else {
            const payload = `[  {
                "ambulance_tracking_step_id": ${appointment.next_step_id},
                "appointment_id": ${appointment.id},
          
                "created_by": "${state.user_id}",
                "user_selection" : ${JSON.stringify(steps)}
            }]`;
            setLoading(true)
            const result = await callAPIForQuery({ input: payload, type: 'insert_ambulance_tracking_step_appointment' }, 'post')
            setLoading(false)
            if (!result.error) {
                alert("Saved Successfully");
                refreshComponent();
            }
        }
    }
    if (loading) {
        return <Loader />
    }
    return <div>
        {appointment?.id && <div className="appointment-grid">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone No</th>
                        <th>Gender</th>
                        <th>Age</th>
                        <th>Created Date</th>

                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td>{appointment.id}</td>
                        <td>{appointment.first_name}</td>
                        <td>{appointment.last_name}</td>
                        <td>{appointment.phone_no}</td>
                        <td>{appointment.gender_name}</td>
                        <td>{appointment.age}</td>
                        <td>{moment(appointment.created_date).format("DD MMM YYYY HH:MM")}</td>
                    </tr>
                </tbody>
            </table>
        </div>}
        {statusTrack?.length > 0 && <div className="appointment-grid">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Value</th>
                        <th>Created Date</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        statusTrack.map(((status: any) => {
                            return (<tr key={status.id}>
                                <td>{status.field}</td>
                                <td>
                                    {/* {!status.field.includes("upload") ? status.value : <a className="download-file"
                                    onClick={() => {
                                        downloadFile(status.field, status.value)

                                    }} >Download File</a>} */}

                                    {!status.field.includes("upload") ? status.value : <FontAwesomeIcon icon={faDownload} style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            downloadFile(status.field, status.value)
                                        }} />}

                                </td>
                                <td>{moment(status.value_created_date).format("DD MMM YYYY HH:MM")}</td>
                            </tr>)
                        }))
                    }
                </tbody>
            </table>
        </div>}

        {appointment.next_step_id === 1 && (<div className="row">
            <div className="col-lg-2 form-option">
                <div className="field-title">Start KM</div>
                <input className="form-control" value={input.start_km || ''} onChange={(event: any) => {
                    updateInputInfo("start_km", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option" >
                <div className="field-title">Start Location</div>
                <input className="form-control" value={input.start_location || ''} onChange={(event: any) => {
                    updateInputInfo("start_location", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option" >
                <div className="field-title">Upload</div>
                <input type="file" className="form-control" onChange={(event: any) => { handleFileUpload(event.currentTarget, "start_km_upload") }} />
                <div className="action-set no-left-padding no-top-padding">
                    <div className="link-text" onClick={() => { downloadFile("start_km_upload", input["start_km_upload"]) }}>View File</div>
                </div>
            </div>

        </div>)}
        {appointment.next_step_id === 2 && (<div className="row">
            <div className="col-lg-2 form-option">
                <div className="field-title">Destination KM</div>
                <input className="form-control" value={input.destination_km || ''} onChange={(event: any) => {
                    updateInputInfo("destination_km", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option">
                <div className="field-title">Destination Location</div>
                <input className="form-control" value={input.destination_location || ''} onChange={(event: any) => {
                    updateInputInfo("destination_location", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option">
                <div className="field-title">Upload</div>
                <input type="file" className="form-control" onChange={(event: any) => { handleFileUpload(event.currentTarget, "destination_km_upload") }} />
                <div className="action-set no-left-padding no-top-padding">
                    <div className="link-text" onClick={() => { downloadFile("destination_km_upload", input["destination_km_upload"]) }}>View File</div>
                </div>
            </div>

        </div>)}
        {appointment.next_step_id === 3 && (<div className="row">
            <div className="col-lg-2 form-option">
                <div className="field-title">Return KM</div>
                <input className="form-control" value={input.return_km || ''} onChange={(event: any) => {
                    updateInputInfo("return_km", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option">
                <div className="field-title">Return Location</div>
                <input className="form-control" value={input.return_location || ''} onChange={(event: any) => {
                    updateInputInfo("return_location", event.target.value)
                }} />
            </div>
            <div className="col-lg-2 form-option">
                <div className="field-title">Upload</div>
                <input type="file" className="form-control" onChange={(event: any) => { handleFileUpload(event.currentTarget, "return_km_upload") }} />
                <div className="action-set no-left-padding no-top-padding">
                    <div className="link-text" onClick={() => { downloadFile("return_km_upload", input["return_km_upload"]) }}>View File</div>
                </div>
            </div>

        </div>)}
        {appointment.next_step_id <= 3 && (<div className="action-set" >
            <input type="button" value="Save" onClick={onSave} />
        </div>)}
    </div>
}